import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface BusinessOwnerBlockDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  action?: string;
}

export const BusinessOwnerBlockDialog = ({
  open,
  onOpenChange,
  action,
}: BusinessOwnerBlockDialogProps) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Add a parent or carer profile</DialogTitle>
          <DialogDescription className="pt-2 leading-relaxed">
            Your account is currently set up as a business listing, so social
            features like interested, going, friend requests and
            chats {action ? `(${action}) ` : ""}aren't available yet. You can
            add a member profile from Business {">"} Profile to take part.
            Your business listing stays exactly as it is.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            Not now
          </Button>
          <Button
            onClick={() => {
              onOpenChange(false);
              navigate(user ? "/business?tab=profile#member-profile" : "/auth");
            }}
          >
            Go to Profile
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
